import React from 'react';
import { EVBarriersMetrics, IncomeQuintile } from '../../services/evAdoptionBarriersService';
import { KeyMetrics, KeyMetric } from './KeyMetrics';

interface EVBarriersMetricsProps {
  metrics: EVBarriersMetrics;
  quintiles: IncomeQuintile[];
}

const EVBarriersMetricsComponent: React.FC<EVBarriersMetricsProps> = ({ metrics, quintiles }) => {
  return (
    <KeyMetrics>
      <KeyMetric
        value={metrics.correlation.toFixed(3)}
        label="Tract-level income–adoption correlation (r)"
        color="#8b5cf6"
      />
      <KeyMetric
        value={`${metrics.evGap.toFixed(2)}`}
        label="Highest- vs lowest-income quintile adoption gap (EVs per 100 residents)"
        color="#3b82f6"
      />
      <KeyMetric
        value={`$${(metrics.quintileGap / 1000).toFixed(0)}K`}
        label="Median-income gap between quintiles"
        color="#10b981"
      />
      <KeyMetric
        value={metrics.sampleSize.toString()}
        label="Census tracts analyzed"
        color="#f59e0b"
      />
    </KeyMetrics>
  );
};

export default EVBarriersMetricsComponent;
